<template>
  <div class="card">
    <div class="mobile-clock-widget" id="infra-clock">
      <div>
        <ul class="clock" id="clock">
          <li class="hour" id="hour" ref="hour"></li>
          <li class="min" id="min" ref="min"></li>
          <li class="sec" id="sec" ref="sec"></li>
        </ul>

        <div class="date f-24 mb-2" id="date">
          <span id="monthDay">{{ clockset.month }} {{ clockset.date }}</span
          >, <span id="year" v-text="clockset.year"></span>
        </div>
        <div>
          <p class="m-0 f-14 text-light">Augsburg, Deutschland</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Clock",
  data() {
    return {
      clockset: {
        sec: 0,
        min: 0,
        hour: 0,
        date: null,
        month: null,
        year: null,
      },
      months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    };
  },
  mounted() {
    this.clock();
  },
  methods: {
    clock: function() {      
      if(!this.$refs.sec) return;
      var cd = new Date();

      this.clockset.hour = 30 * ((cd.getHours() % 12) + cd.getMinutes() / 60);
      this.clockset.min = 6 * cd.getMinutes();
      this.clockset.sec = 6 * cd.getSeconds();

      this.clockset.date = cd.getDate();
      this.clockset.month = this.months[cd.getMonth()];
      this.clockset.year = cd.getFullYear();

      
      this.$refs.sec.style.cssText = "-webkit-transform:rotate(" + this.clockset.sec + "deg);";
      this.$refs.min.style.cssText = "-webkit-transform:rotate(" + this.clockset.min + "deg);";
      this.$refs.hour.style.cssText = "-webkit-transform:rotate(" + this.clockset.hour + "deg);";

      setTimeout(this.clock, 1000);
    },
  },
};
</script>

<style></style>
